import { ofType } from 'redux-observable';
import { EMPTY } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

import * as Actions from './app-header.actions';
import { FeatureFlags } from '../../feature-flags/feature-flags';
import { initSupportChat } from '../../global/support-chat/init-support-chat';
import { getPreferredLocale } from '../../intl/get-intl';
import { getPartitionNumber } from '../../services/partition-service';
import Global from '../../store/global-selectors';

// TODO(sierra-widget-removal): unused after Shippy/Sierra split — delete in follow-up PR along with init-support-chat and the Sierra/Sunco widget code.
export const launchEnterpriseChat = (action$, { getState }) =>
  action$.pipe(
    ofType(Actions.LAUNCH_ENTERPRISE_CHAT),
    mergeMap((action) => {
      const { chatInitOrigin } = action.payload || {};
      const state = getState();
      const { name, email } = Global.selectUserCurrentUserInfo(state);
      const sellerId = Global.selectSellerSellerId(state);
      const userId = Global.selectUserCurrentUserId(state);
      const homeCountry = Global.selectSellerHomeCountry(state);
      const subscriptionPlan = Global.selectSellerSubscriptionPlanInfo(state);
      const activationDate = Global.selectSellerActivationDate(state);
      const locale = getPreferredLocale(state);
      const userHasAdmin = Global.selectUserhasAdministrationRole(state);
      const { billingCycleEndDateTimeUTC: billingCycleDate } = Global.selectSellerPlanInfo(state);
      const featureFlags = new FeatureFlags({ state });

      const ssEnvironment = `ss${getPartitionNumber()}`;
      const organizationIdSeller = Global.selectSellerZendeskOrganizationID(state) || '';
      const ssPlanVolume = 'unknown'; // todo add this back in when the backend data comes.
      const businessName = Global.selectSellerCompanyName(state) || 'unknown';
      const enableShipstationReturns = Global.selectSellerSellerSetting(state, { settingName: 'EnableShipstationReturns' });
      const features = JSON.stringify(enableShipstationReturns?.toLowerCase() === 'true' ? ['ShipstationReturns'] : []);

      initSupportChat({
        name,
        email,
        sellerId,
        homeCountry,
        subscriptionPlan,
        activationDate,
        locale,
        userHasAdmin,
        billingCycleDate,
        featureFlags,
        ssEnvironment,
        organizationIdSeller,
        ssPlanVolume,
        businessName,
        userId,
        chatInitOrigin,
        features,
      });

      return EMPTY;
    }),
  );
